export default __webpack_public_path__ + "img/security.dd62eb.svg";